export const darkTheme = {
  body: "#0f0f0f",
  text: "#e4e4e7",
  highlight: "#3730a3",
  dark: "#000000",
  surface: "#18181b",
  surfaceLight: "#27272a",
  border: "#27272a",
  primary: "#8b5cf6",
  success: "#10b981",
  error: "#ef4444",
  warning: "#f59e0b",
  secondaryText: "#a1a1aa",
  imageHighlight: "#8b5cf6",
  compImgHighlight: "#27272a",
  jacketColor: "#4c1d95",
  headerColor: "#8b5cf677",
};

export const lightTheme = {
  body: "#ffffff",
  text: "#18181b",
  highlight: "#f4f4f5",
  dark: "#18181b",
  surface: "#fafafa",
  surfaceLight: "#f4f4f5",
  border: "#e4e4e7",
  primary: "#7c3aed",
  success: "#059669",
  error: "#dc2626",
  warning: "#d97706",
  secondaryText: "#71717a",
  imageHighlight: "#7c3aed",
  compImgHighlight: "#e4e4e7",
  jacketColor: "#8b5cf6",
  headerColor: "#7c3aed77",
};

export const darkPurpleTheme = {
  body: "#0f0a1f",
  text: "#e9d5ff",
  highlight: "#2e1065",
  dark: "#0a0414",
  surface: "#1e1338",
  surfaceLight: "#2e1065",
  border: "#4c1d95",
  primary: "#a855f7",
  success: "#34d399",
  error: "#f87171",
  warning: "#fbbf24",
  secondaryText: "#c084fc",
  imageHighlight: "#a855f7",
  compImgHighlight: "#2e1065",
  jacketColor: "#6b21a8",
  headerColor: "#a855f777",
};

// Default theme
export const chosenTheme = darkTheme;